import { render, staticRenderFns } from "./List.vue?vue&type=template&id=638bab5f&scoped=true"
var script = {}
import style0 from "./List.vue?vue&type=style&index=0&id=638bab5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638bab5f",
  null
  
)

export default component.exports